import { useQueryClient } from "@tanstack/react-query"

import { invalidateDocumentProject, invalidateDocumentsList } from "@l2r-front/l2r-app-doc"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { riskZonesQueryKeys } from "../queries/queryKeys"

import { useRiskZoneMutation } from "./useRiskZoneMutation"

export function useRiskZoneUpdateDocument(
    riskZoneUuid,
    queryParameters,
    config = {},
) {
    const url = `risk_zone_clusters/${riskZoneUuid}/`
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    const axiosFn = (url, values) => {
        const formData = new FormData()
        Object.entries(values).forEach(([key, value]) => {
            if (key === "document") {
                Object.entries(values[key]).forEach(([docKey, docValue]) => {
                    if (Array.isArray(docValue)) {
                        formData.append(`${key}.${docKey}`, JSON.stringify(docValue))
                    } else {
                        formData.append(`${key}.${docKey}`, docValue)
                    }
                })
            } else {
                formData.append(key, value)
            }
        })

        const headers = values.document ? { "Content-Type": "multipart/form-data" } : {}

        return axiosInstance.patch(url, formData, {
            headers: headers,
        })
    }

    return useRiskZoneMutation(
        url,
        axiosFn,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: riskZonesQueryKeys.feature(data.risk_zone.identifier.toString()) })
                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)
                config.onSuccess?.(data)
            },
        },
    )
}